import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AdminApiClient } from '@guiker/rental-listing-shared'
export const useAdminListingApiClient = useAuthenticatedApiClient(AdminApiClient)
